(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-banner-2-0"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.hb20Ready === 'true') return;
      root.dataset.hb20Ready = 'true';

      const slides = Array.from(root.querySelectorAll('[data-hb20-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-hb20-dot]'));
      const previous = root.querySelector('[data-hb20-prev]');
      const next = root.querySelector('[data-hb20-next]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let active = 0;
      let timer;
      let touchStart = 0;

      const show = (index) => {
        if (!slides.length) return;
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const selected = slideIndex === active;
          slide.classList.toggle('is-active', selected);
          slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
        });
        dots.forEach((dot, dotIndex) => {
          const selected = dotIndex === active;
          dot.classList.toggle('is-active', selected);
          dot.setAttribute('aria-selected', selected ? 'true' : 'false');
        });
      };

      const stop = () => window.clearInterval(timer);
      const start = () => {
        stop();
        if (root.dataset.autoplay !== 'true' || reduceMotion || slides.length < 2) return;
        const interval = Math.max(3000, Number(root.dataset.interval) || 5000);
        timer = window.setInterval(() => show(active + 1), interval);
      };

      previous?.addEventListener('click', () => {
        show(active - 1);
        start();
      });
      next?.addEventListener('click', () => {
        show(active + 1);
        start();
      });
      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          show(Number(dot.dataset.hb20Dot));
          start();
        });
      });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      root.addEventListener('touchstart', (event) => {
        touchStart = event.changedTouches[0]?.clientX || 0;
      }, { passive: true });
      root.addEventListener('touchend', (event) => {
        const distance = (event.changedTouches[0]?.clientX || 0) - touchStart;
        if (Math.abs(distance) < 45) return;
        show(active + (distance < 0 ? 1 : -1));
        start();
      }, { passive: true });

      start();
    };

    const initAll = () => document.querySelectorAll('[data-hb20]').forEach(init);
    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-catalog-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zn-home-catalog')) {
    customElements.define(
      'zn-home-catalog',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', this.handleClick);
          this.addEventListener('keydown', this.handleKeydown);
          this.addEventListener('shopify:block:select', this.handleBlockSelect);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.handleClick);
          this.removeEventListener('keydown', this.handleKeydown);
          this.removeEventListener('shopify:block:select', this.handleBlockSelect);
        }

        handleClick = (event) => {
          const mainButton = event.target.closest('[data-zn-main-tab]');
          if (mainButton && this.contains(mainButton)) {
            this.activateMain(mainButton.dataset.znMainTab, true);
            return;
          }

          const categoryButton = event.target.closest('[data-zn-category-tab]');
          if (categoryButton && this.contains(categoryButton)) {
            this.activateCategory(categoryButton.dataset.znCategoryTab);
          }
        };

        handleKeydown = (event) => {
          const button = event.target.closest('[role="tab"]');
          if (!button || !this.contains(button)) return;
          if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;

          const tablist = button.closest('[role="tablist"]');
          const buttons = Array.from(tablist.querySelectorAll(':scope > [role="tab"]'));
          const currentIndex = buttons.indexOf(button);
          let nextIndex = currentIndex;

          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = buttons.length - 1;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % buttons.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + buttons.length) % buttons.length;

          event.preventDefault();
          buttons[nextIndex]?.focus();
          buttons[nextIndex]?.click();
        };

        handleBlockSelect = (event) => {
          const categoryPanel = event.target.closest('[data-zn-category-panel]');
          if (!categoryPanel || !this.contains(categoryPanel)) return;
          this.activateMain(categoryPanel.dataset.znParentPanel, false);
          this.activateCategory(categoryPanel.dataset.znCategoryPanel);
        };

        activateMain(key, allowScroll) {
          this.querySelectorAll('[data-zn-main-tab]').forEach((button) => {
            button.setAttribute('aria-selected', String(button.dataset.znMainTab === key));
          });

          let activePanel;
          this.querySelectorAll('[data-zn-main-panel]').forEach((panel) => {
            const isActive = panel.dataset.znMainPanel === key;
            panel.hidden = !isActive;
            if (isActive) activePanel = panel;
          });

          if (
            allowScroll &&
            activePanel &&
            this.dataset.scrollMobile === 'true' &&
            this.dataset.designMode !== 'true' &&
            window.matchMedia('(max-width: 767px)').matches
          ) {
            window.requestAnimationFrame(() => activePanel.scrollIntoView({ behavior: 'smooth', block: 'start' }));
          }
        }

        activateCategory(id) {
          const activePanel = this.querySelector(`[data-zn-category-panel="${id}"]`);
          const parent = activePanel?.closest('[data-zn-main-panel]');
          if (!parent) return;

          parent.querySelectorAll('[data-zn-category-tab]').forEach((button) => {
            button.setAttribute('aria-selected', String(button.dataset.znCategoryTab === id));
          });
          parent.querySelectorAll('[data-zn-category-panel]').forEach((panel) => {
            panel.hidden = panel.dataset.znCategoryPanel !== id;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mix-product-description"] && !Shopify.designMode) return;
  try {
    
    (function () {
      function runScripts(container) {
        container.querySelectorAll('script').forEach(function (oldScript) {
          var newScript = document.createElement('script');
          Array.prototype.forEach.call(oldScript.attributes, function (attribute) {
            newScript.setAttribute(attribute.name, attribute.value);
          });
          newScript.textContent = oldScript.textContent;
          oldScript.replaceWith(newScript);
        });
      }

      function initMixProductDescription(root) {
        if (!root || root.dataset.mpdReady === 'true') return;
        root.dataset.mpdReady = 'true';

        var choices = Array.prototype.slice.call(root.querySelectorAll('[data-mpd-url]'));
        var content = root.querySelector('[data-mpd-content]');
        var status = root.querySelector('[data-mpd-status]');
        var cache = new Map();
        var preloads = new Map();
        var controller = null;

        function setActive(choice) {
          choices.forEach(function (item) {
            var active = item === choice;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-selected', active ? 'true' : 'false');
            item.setAttribute('tabindex', active ? '0' : '-1');
          });
        }

        function collectDescription(pageHtml) {
          var parsed = new DOMParser().parseFromString(pageHtml, 'text/html');
          var pageMain = parsed.querySelector('#MainContent') || parsed.querySelector('main');
          if (!pageMain) return '';

          var productLayout = pageMain.querySelector('.product-information--main');
          var productSection = productLayout ? productLayout.closest('[id^="shopify-section-"]') : null;
          var parts = [];

          if (productSection) {
            var accordion = productSection.querySelector('.accrodion--accordion_U9n4kg');
            var productDescription = productSection.querySelector('.text-block--product_description_DwV47J');
            if (accordion || productDescription) {
              parts.push('<div class="mpd__main-copy page-width">' +
                (accordion ? accordion.outerHTML : '') +
                (productDescription ? productDescription.outerHTML : '') +
                '</div>');
            }

            var nextSection = productSection.nextElementSibling;
            while (nextSection) {
              var sectionId = nextSection.id || '';
              if (/product_recommendations|blog_posts|recently_viewed|footer/i.test(sectionId)) break;
              parts.push(nextSection.outerHTML);
              nextSection = nextSection.nextElementSibling;
            }
          }

          return parts.join('');
        }

        async function fetchDescription(productUrl, signal) {
          if (cache.has(productUrl)) return cache.get(productUrl);
          if (preloads.has(productUrl)) return preloads.get(productUrl);

          var request = fetch(productUrl, {
            signal: signal,
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          }).then(async function (response) {
            if (!response.ok) throw new Error('Request failed');
            var descriptionHtml = collectDescription(await response.text());
            if (!descriptionHtml) throw new Error('Description not found');
            cache.set(productUrl, descriptionHtml);
            return descriptionHtml;
          });

          if (!signal) preloads.set(productUrl, request);
          try {
            return await request;
          } finally {
            if (!signal) preloads.delete(productUrl);
          }
        }

        function preloadRemainingChoices() {
          choices.slice(1).forEach(function (choice) {
            var productUrl = choice.getAttribute('data-mpd-url');
            if (!productUrl || cache.has(productUrl) || preloads.has(productUrl)) return;
            fetchDescription(productUrl).catch(function () {});
          });
        }

        async function showProduct(choice, emitChange) {
          if (!choice || !content) return;
          setActive(choice);
          var productUrl = choice.getAttribute('data-mpd-url');
          var handle = choice.getAttribute('data-mpd-handle') || '';
          content.setAttribute('aria-busy', 'true');
          root.classList.add('is-loading');
          if (status) status.hidden = true;

          try {
            if (controller) controller.abort();
            controller = new AbortController();
            var descriptionHtml = await fetchDescription(productUrl, controller.signal);
            content.innerHTML = descriptionHtml;
            runScripts(content);
            content.removeAttribute('aria-busy');
            root.classList.remove('is-loading');
            if (status) status.hidden = true;
            document.dispatchEvent(new CustomEvent('shopify:section:load'));
            if (emitChange) {
              window.dispatchEvent(new CustomEvent('zew:mix-product-change', {
                detail: { index: choice.getAttribute('data-mpd-index'), handle: handle, source: root.id }
              }));
            }
          } catch (error) {
            if (error.name === 'AbortError') return;
            content.removeAttribute('aria-busy');
            root.classList.remove('is-loading');
            if (status) status.hidden = true;
          }
        }

        choices.forEach(function (choice, index) {
          choice.addEventListener('click', function () { showProduct(choice, true); });
          choice.addEventListener('keydown', function (event) {
            if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
            event.preventDefault();
            var nextIndex = event.key === 'ArrowRight' ? index + 1 : index - 1;
            if (nextIndex < 0) nextIndex = choices.length - 1;
            if (nextIndex >= choices.length) nextIndex = 0;
            choices[nextIndex].focus();
            showProduct(choices[nextIndex], true);
          });
        });

        window.addEventListener('zew:mix-product-change', function (event) {
          var detail = event.detail || {};
          if (detail.source === root.id) return;
          var match = choices.find(function (choice) {
            return detail.handle && choice.getAttribute('data-mpd-handle') === detail.handle;
          });
          if (!match && detail.index !== undefined) match = choices[Number(detail.index)];
          if (match) showProduct(match, false);
        });

        showProduct(choices[0], false).then(preloadRemainingChoices);
      }

      function initAll() {
        document.querySelectorAll('[data-mix-product-description]').forEach(initMixProductDescription);
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll, { once: true });
      } else {
        initAll();
      }
      document.addEventListener('shopify:section:load', initAll);
    }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-product-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selectors = {
      root: '[data-pet-finder]',
      form: '[data-quiz-form]',
      step: '[data-step]',
      next: '[data-next]',
      prev: '[data-prev]',
      validation: '[data-validation]',
      results: '[data-results]',
      loading: '[data-loading]'
    };

    const normalize = (value) => String(value || '')
      .toLocaleLowerCase('pl-PL')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

    const proteinTerms = {
      poultry: ['kurcz', 'indyk', 'drob', 'kaczk', 'ges', 'bazant', 'przepior'],
      beef: ['wolow'],
      pork: ['wieprz'],
      lamb: ['jagniec'],
      fish: ['ryb', 'dorsz', 'losos'],
      grain: ['zboz', 'gluten', 'ryz', 'kukurydz', 'pszenic'],
      rice: ['ryz'],
      corn: ['kukurydz'],
      wheat: ['pszenic'],
      soy: ['soj'],
      yeast: ['drozdz'],
      potato: ['ziemniak'],
      sweet_potato: ['batat'],
      pumpkin: ['dynia'],
      rabbit: ['krolik'],
      turkey: ['indyk'],
      venison: ['dzicz'],
      chicken: ['kurcz'],
      duck: ['kaczk'],
      goose: ['ges'],
      deer: ['jelen', 'sarna', 'renifer'],
      kangaroo: ['kangur'],
      goat: ['kozin'],
      sheep: ['owca', 'owcz'],
      pheasant: ['bazant'],
      quail: ['przepior'],
      ostrich: ['strus'],
      tuna: ['tunczyk'],
      salmon: ['losos'],
      cod: ['dorsz'],
      seafood: ['krewet', 'kryl']
    };

    const labels = {
      species: { dog: 'Pies', cat: 'Kot' },
      age: { junior: 'Okres wzrostu', adult: 'Dorosły', senior: 'Senior' },
      size: { small: 'Mały', medium: 'Średni', large: 'Duży' },
      activity: { low: 'Spokojny', normal: 'Umiarkowanie aktywny', high: 'Bardzo aktywny' },
      goal: {
        everyday: 'Dieta codzienna',
        elimination: 'Dieta eliminacyjna',
        digestion: 'Wrażliwe trawienie',
        weight_control: 'Kontrola masy ciała',
        active: 'Dieta dla aktywnych',
        skin: 'Skóra i sierść'
      }
    };

    const emit = (name, detail = {}) => {
      const payload = { event: `zn_${name}`, ...detail };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      document.dispatchEvent(new CustomEvent(`zn:${name}`, { detail }));
    };

    const getTags = (product) => {
      if (Array.isArray(product.tags)) return product.tags.map(normalize);
      return String(product.tags || '').split(',').map(normalize).filter(Boolean);
    };

    const productText = (product) => normalize([
      product.title,
      product.product_type,
      product.vendor,
      product.body_html,
      ...getTags(product)
    ].join(' '));

    const containsAny = (text, terms = []) => terms.some((term) => text.includes(term));

    const isSpecies = (text, species) => {
      const cat = containsAny(text, ['dla kota', 'karma dla kota', ' kot ', 'kocie', 'kociat']);
      const dog = containsAny(text, ['dla psa', 'karma dla psa', ' pies ', 'psow', 'szczeni']);
      return species === 'cat' ? cat && !dog : dog && !cat;
    };

    const isTreat = (text) => containsAny(text, ['przysmak', 'gryzak', 'kostk', 'treser', 'paski', 'ucho ', 'uszy ']);
    const isBundle = (text) => containsAny(text, ['mix smak', 'zestaw', '6 x ', '12 x ', '24 x ', '6x', '12x', '24x']);

    const isSafeFor = (text, allergy) => {
      const safePhrases = {
        poultry: ['bez drobiu', 'bez kurczaka i indyka'],
        beef: ['bez wolowiny'],
        pork: ['bez wieprzowiny'],
        lamb: ['bez jagnieciny'],
        fish: ['bez ryb', 'bez ryby'],
        grain: ['bez zboz', 'bezzboz', 'bez glutenu'],
        rice: ['bez ryzu'],
        corn: ['bez kukurydzy'],
        wheat: ['bez pszenicy'],
        soy: ['bez soi'],
        yeast: ['bez drozdzy'],
        potato: ['bez ziemniaka'],
        sweet_potato: ['bez batata'],
        pumpkin: ['bez dyni'],
        rabbit: ['bez krolika'],
        duck: ['bez kaczki'],
        goose: ['bez gesi'],
        venison: ['bez dziczyzny'],
        deer: ['bez jelenia', 'bez sarny', 'bez renifera'],
        kangaroo: ['bez kangura'],
        goat: ['bez koziny'],
        sheep: ['bez owcy', 'bez miesa owczego'],
        pheasant: ['bez bazanta'],
        quail: ['bez przepior'],
        ostrich: ['bez strusia'],
        chicken: ['bez kurczaka'],
        turkey: ['bez indyka'],
        tuna: ['bez tunczyka'],
        salmon: ['bez lososia'],
        cod: ['bez dorsza'],
        seafood: ['bez krewetek', 'bez kryla']
      };
      if (containsAny(text, safePhrases[allergy])) return true;
      const terms = proteinTerms[allergy] || [];
      const withoutNegativeClaims = terms.reduce((value, term) => value.replaceAll(`bez ${term}`, ''), text);
      return !containsAny(withoutNegativeClaims, terms);
    };

    const scoreProduct = (product, answers, extra = false) => {
      const text = productText(product);
      if (!isSpecies(text, answers.species)) return null;
      if (answers.allergies.some((allergy) => !isSafeFor(text, allergy))) return null;

      const treat = isTreat(text);
      if (extra && !treat && !isBundle(text)) return null;
      if (!extra && treat) return null;

      let score = 100;
      const reasons = [];

      if (answers.age === 'junior') {
        if (containsAny(text, ['junior', 'szczeni', 'kocie', 'kociat'])) {
          score += 28;
          reasons.push('dopasowana do wzrostu');
        } else {
          score -= 34;
        }
      } else if (answers.age === 'senior') {
        if (text.includes('senior')) {
          score += 26;
          reasons.push('dla seniora');
        } else if (text.includes('dorosl')) {
          score += 5;
        }
      } else if (text.includes('dorosl')) {
        score += 18;
        reasons.push('dla dorosłego pupila');
      }

      if (answers.size === 'small' && containsAny(text, ['400 g', '400g'])) score += 7;
      if (answers.size === 'large' && containsAny(text, ['800 g', '800g', 'zestaw', 'mix'])) score += 7;

      if (answers.activity === 'high' && containsAny(text, ['energia 120-140', 'tluszcz 9-12'])) {
        score += 8;
        reasons.push('dla aktywnych');
      }
      if (answers.activity === 'low' && containsAny(text, ['energia 80-100', 'lekkostraw'])) {
        score += 8;
        reasons.push('lżejsza receptura');
      }

      if (answers.goal === 'elimination' && containsAny(text, ['mono-protein', 'monoprotein', 'jedno zrodlo bialka', 'dieta eliminacyjna', 'hipoalerg'])) {
        score += 28;
        reasons.push('pasuje do diety eliminacyjnej');
      }
      if (answers.goal === 'digestion' && containsAny(text, ['wsparcie trawienia', 'lekkostraw', 'prebiot', 'jelit'])) {
        score += 20;
        reasons.push('wsparcie trawienia');
      }
      if (answers.goal === 'skin' && containsAny(text, ['omega-3', 'skora i siersc', 'olej z lososia'])) {
        score += 20;
        reasons.push('wsparcie skóry i sierści');
      }
      if (answers.goal === 'everyday' && containsAny(text, ['pelnoporcj', 'karma mokra'])) {
        score += 14;
        reasons.push('pełnoporcjowa na co dzień');
      }
      if (answers.goal === 'weight_control' && containsAny(text, ['lekkostraw', 'niska zawartosc tluszczu', 'kontrola masy', 'energia 80-100'])) {
        score += 18;
        reasons.push('lżejsza receptura');
      }
      if (answers.goal === 'active' && containsAny(text, ['dla aktywnych', 'wysoka energia', 'energia 120-140', 'tluszcz 9-12'])) {
        score += 18;
        reasons.push('dla aktywnego pupila');
      }

      if (answers.protein !== 'any' && containsAny(text, proteinTerms[answers.protein])) {
        score += 16;
        reasons.push('ulubione mięso');
      }

      const isMono = containsAny(text, ['mono-protein', 'monoprotein', 'jedno zrodlo bialka']);
      const isMulti = containsAny(text, ['wiele zrodel bialka', 'wielobialk', 'dwa zrodla bialka']);
      if (answers.proteinStructure === 'mono' && isMono) {
        score += 22;
        reasons.push('jedno źródło białka');
      }
      if (answers.proteinStructure === 'mono' && isMulti) score -= 28;
      if (answers.proteinStructure === 'multi' && isMulti) {
        score += 22;
        reasons.push('wiele źródeł białka');
      }
      if (answers.proteinStructure === 'multi' && isMono) score -= 16;
      if (answers.format === 'mix' && isBundle(text)) score += 20;
      if (answers.format === 'daily' && !isBundle(text) && containsAny(text, ['karma', 'puszka'])) score += 10;
      if (getTags(product).some((tag) => tag.includes('bez sztucznych dodatkow'))) score += 3;

      if (!reasons.length) reasons.push('zgodna z odpowiedziami');
      return { product, score, reasons: [...new Set(reasons)].slice(0, 3) };
    };

    const recipeKey = (product) => normalize(product.title)
      .replace(/\b\d+\s*x\b|\b\d+x\b|\b\d+\s*g\b|\b\d+g\b/g, ' ')
      .replace(/mokra karma|karma mokra|dla psa|dla kota|zew natury|junior|premium|mono[ -]?protein|bogata w/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    const dominantProtein = (product) => {
      const text = productText(product);
      const order = ['rabbit', 'turkey', 'duck', 'goose', 'lamb', 'sheep', 'venison', 'deer', 'kangaroo', 'goat', 'pheasant', 'quail', 'ostrich', 'beef', 'pork', 'chicken', 'tuna', 'salmon', 'cod', 'seafood', 'fish'];
      return order.find((key) => containsAny(text, proteinTerms[key])) || recipeKey(product);
    };

    const pickDiverse = (items, limit) => {
      const selected = [];
      const recipes = new Set();
      const proteins = new Set();
      for (const item of items) {
        const recipe = recipeKey(item.product);
        const protein = dominantProtein(item.product);
        if (recipes.has(recipe) || proteins.has(protein)) continue;
        selected.push(item);
        recipes.add(recipe);
        proteins.add(protein);
        if (selected.length >= limit) return selected;
      }
      for (const item of items) {
        const recipe = recipeKey(item.product);
        if (recipes.has(recipe)) continue;
        selected.push(item);
        recipes.add(recipe);
        if (selected.length >= limit) break;
      }
      return selected;
    };

    const money = (value, currency) => {
      const amount = Number(String(value || 0).replace(',', '.'));
      try {
        return new Intl.NumberFormat('pl-PL', { style: 'currency', currency }).format(amount);
      } catch (error) {
        return `${amount.toFixed(2)} zł`;
      }
    };

    const imageUrl = (product) => {
      const image = product.images?.[0];
      return typeof image === 'string' ? image : image?.src || product.image?.src || '';
    };

    const availableVariant = (product) => product.variants?.find((variant) => variant.available !== false) || product.variants?.[0];

    const buildCard = (item, index, currency, extra = false) => {
      const product = item.product;
      const variant = availableVariant(product);
      const article = document.createElement('article');
      article.className = 'pet-finder__product';
      const match = Math.min(98, Math.max(76, 78 + Math.round((item.score - 100) * 0.22)));
      const img = imageUrl(product);
      article.innerHTML = `
        <div class="pet-finder__product-media">
          ${img ? `<img src="${img}" alt="" loading="lazy" width="300" height="300">` : ''}
        </div>
        <div class="pet-finder__product-copy">
          ${extra ? '' : `<span class="pet-finder__match">${index === 0 ? 'Najlepsze dopasowanie' : `Dopasowanie ${match}%`}</span>`}
          <h3>${product.title}</h3>
          <div class="pet-finder__reasons">${item.reasons.map((reason) => `<span class="pet-finder__reason">${reason}</span>`).join('')}</div>
          <p class="pet-finder__price">${money(variant?.price, currency)}</p>
          <div class="pet-finder__product-actions">
            <a href="${product.url || `/products/${product.handle}`}" data-product-view>Zobacz produkt</a>
            ${variant ? `<button class="is-primary" type="button" data-add-product data-variant-id="${variant.id}" data-product-handle="${product.handle}">Dodaj do koszyka</button>` : ''}
          </div>
        </div>`;
      return article;
    };

    const init = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const form = root.querySelector(selectors.form);
      const steps = [...root.querySelectorAll(selectors.step)];
      const next = root.querySelector(selectors.next);
      const prev = root.querySelector(selectors.prev);
      const validation = root.querySelector(selectors.validation);
      const progressWrap = root.querySelector('[data-progress-wrap]');
      const progressLabel = root.querySelector('[data-step-label]');
      const progressValue = root.querySelector('[data-progress-value]');
      const progressBar = root.querySelector('[data-progress-bar]');
      const loading = root.querySelector(selectors.loading);
      const results = root.querySelector(selectors.results);
      const mainResults = root.querySelector('[data-main-results]');
      const extraResults = root.querySelector('[data-extra-results]');
      const extrasWrap = root.querySelector('[data-extras-wrap]');
      const summary = root.querySelector('[data-summary]');
      const cartStatus = root.querySelector('[data-cart-status]');
      const restart = root.querySelector('[data-restart]');
      const sizeQuestion = root.querySelector('[data-size-question]');
      const sizeHint = root.querySelector('[data-size-hint]');
      const sizeSmall = root.querySelector('[data-size-small]');
      const sizeSmallRange = root.querySelector('[data-size-small-range]');
      const sizeMedium = root.querySelector('[data-size-medium]');
      const sizeMediumRange = root.querySelector('[data-size-medium-range]');
      const sizeLarge = root.querySelector('[data-size-large]');
      const sizeLargeRange = root.querySelector('[data-size-large-range]');
      const weightInput = root.querySelector('[data-weight-input]');
      let current = 0;
      let catalog = null;

      const answers = () => {
        const data = new FormData(form);
        return {
          species: data.get('species'),
          age: data.get('age'),
          size: data.get('size'),
          weight: Number(data.get('weight')),
          activity: data.get('activity'),
          goal: data.get('goal'),
          allergies: data.getAll('allergies'),
          protein: data.get('protein') || 'any',
          proteinStructure: data.get('protein_structure') || 'any',
          format: data.get('format') || 'daily'
        };
      };

      const updateProgress = () => {
        const percent = Math.round(((current + 1) / steps.length) * 100);
        progressLabel.textContent = `Pytanie ${current + 1} z ${steps.length}`;
        progressValue.textContent = `${percent}%`;
        progressBar.style.width = `${percent}%`;
        prev.hidden = current === 0;
        next.textContent = current === steps.length - 1 ? 'Pokaż dopasowane produkty' : next.dataset.defaultLabel;
      };

      next.dataset.defaultLabel = next.textContent;

      const updateSizeCopy = (species) => {
        const isCat = species === 'cat';
        sizeQuestion.textContent = isCat ? 'Jakiej wielkości jest Twój kot?' : 'Jakiej wielkości jest Twój pies?';
        sizeHint.textContent = isCat
          ? 'Wybierz budowę kota. Dokładna waga jest pomocna, ale możesz ją pominąć.'
          : 'Wybierz wielkość rasy. Dokładna waga pomaga w dopasowaniu opakowania, ale nie jest obowiązkowa.';
        sizeSmall.textContent = isCat ? 'Mały kot' : 'Mała rasa';
        sizeSmallRange.textContent = isCat ? 'Do około 4 kg' : 'Do około 10 kg';
        sizeMedium.textContent = isCat ? 'Średni kot' : 'Średnia rasa';
        sizeMediumRange.textContent = isCat ? 'Około 4 do 7 kg' : 'Około 10 do 25 kg';
        sizeLarge.textContent = isCat ? 'Duży kot' : 'Duża rasa';
        sizeLargeRange.textContent = isCat ? 'Powyżej 7 kg' : 'Powyżej 25 kg';
        weightInput.max = isCat ? '20' : '120';
        weightInput.placeholder = isCat ? 'np. 5' : 'np. 12';
      };

      const showStep = (index) => {
        steps.forEach((step, stepIndex) => {
          step.hidden = stepIndex !== index;
          step.classList.toggle('is-active', stepIndex === index);
        });
        current = index;
        validation.hidden = true;
        updateProgress();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        steps[current].querySelector('input, select')?.focus({ preventScroll: true });
        emit('quiz_step', { step: current + 1 });
      };

      const validStep = () => {
        const required = [...steps[current].querySelectorAll('[required]')];
        return required.every((input) => {
          if (input.type === 'radio') return Boolean(steps[current].querySelector(`input[name="${input.name}"]:checked`));
          return input.value !== '' && input.checkValidity();
        });
      };

      const loadCatalog = async () => {
        if (catalog) return catalog;
        const response = await fetch(root.dataset.catalogUrl, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Nie udało się pobrać produktów.');
        const data = await response.json();
        catalog = data.products || [];
        return catalog;
      };

      const renderResults = async () => {
        form.hidden = true;
        progressWrap.hidden = true;
        loading.hidden = false;
        const profile = answers();
        try {
          const products = await loadCatalog();
          const primary = products
            .map((product) => scoreProduct(product, profile, false))
            .filter(Boolean)
            .sort((a, b) => b.score - a.score);
          const extras = products
            .map((product) => scoreProduct(product, profile, true))
            .filter(Boolean)
            .sort((a, b) => b.score - a.score);
          const limit = Number(root.dataset.resultLimit) || 4;
          const selected = pickDiverse(primary, limit);
          const selectedHandles = new Set(selected.map((item) => item.product.handle));
          const selectedExtras = pickDiverse(extras.filter((item) => !selectedHandles.has(item.product.handle)), 2);

          mainResults.replaceChildren();
          extraResults.replaceChildren();
          const sizeLabel = profile.species === 'cat'
            ? { small: 'Mały kot', medium: 'Średni kot', large: 'Duży kot' }[profile.size]
            : { small: 'Mała rasa', medium: 'Średnia rasa', large: 'Duża rasa' }[profile.size];
          const structureLabel = { any: 'Dowolna liczba białek', mono: 'Jedno źródło białka', multi: 'Dwa lub więcej źródeł białka' }[profile.proteinStructure];
          summary.innerHTML = [labels.species[profile.species], labels.age[profile.age], sizeLabel, labels.activity[profile.activity], labels.goal[profile.goal], structureLabel]
            .filter(Boolean)
            .map((label) => `<span>${label}</span>`)
            .join('');

          if (selected.length) {
            selected.forEach((item, index) => mainResults.append(buildCard(item, index, root.dataset.moneyCode, false)));
          } else {
            mainResults.innerHTML = '<p>Nie znaleźliśmy pewnego dopasowania przy tych wykluczeniach. Zmień jedną z odpowiedzi lub skontaktuj się z nami. Pomożemy dobrać bezpieczną recepturę.</p>';
          }

          if (selectedExtras.length) {
            selectedExtras.forEach((item, index) => extraResults.append(buildCard(item, index, root.dataset.moneyCode, true)));
            extrasWrap.hidden = false;
          } else {
            extrasWrap.hidden = true;
          }

          emit('quiz_complete', {
            species: profile.species,
            age: profile.age,
            size: profile.size,
            activity: profile.activity,
            goal: profile.goal,
            protein_structure: profile.proteinStructure,
            allergies: profile.allergies.join('|'),
            result_handles: selected.map((item) => item.product.handle).join('|')
          });
          sessionStorage.setItem('zn_pet_quiz', JSON.stringify(profile));
        } catch (error) {
          mainResults.innerHTML = `<p>${error.message || 'Nie udało się przygotować wyników.'}</p>`;
        } finally {
          loading.hidden = true;
          results.hidden = false;
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      };

      next.addEventListener('click', () => {
        if (!validStep()) {
          validation.hidden = false;
          return;
        }
        if (current < steps.length - 1) showStep(current + 1);
        else renderResults();
      });

      prev.addEventListener('click', () => {
        if (current > 0) showStep(current - 1);
      });

      form.addEventListener('change', () => {
        validation.hidden = true;
        if (current === 0) {
          const species = answers().species;
          updateSizeCopy(species);
          emit('quiz_start', { species });
        }
      });

      restart.addEventListener('click', () => {
        form.reset();
        results.hidden = true;
        form.hidden = false;
        progressWrap.hidden = false;
        cartStatus.textContent = '';
        showStep(0);
        emit('quiz_restart');
      });

      root.addEventListener('click', async (event) => {
        const viewLink = event.target.closest('[data-product-view]');
        if (viewLink) emit('quiz_product_view', { url: viewLink.href });

        const button = event.target.closest('[data-add-product]');
        if (!button) return;
        button.disabled = true;
        const original = button.textContent;
        button.textContent = root.dataset.loadingText;
        cartStatus.textContent = '';
        try {
          const formData = new FormData();
          formData.append('id', button.dataset.variantId);
          formData.append('quantity', '1');
          const groupedSections = [];
          document.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: groupedSections } }));
          const sectionIds = [...new Set(groupedSections)];
          if (sectionIds.length) formData.append('sections', sectionIds.join(','));
          const response = await fetch(root.dataset.cartAddUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: formData });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || root.dataset.cartError);
          root.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: data, sourceId: root.id, data: { source: 'pet-finder', itemCount: 1, variantId: button.dataset.variantId, sections: data.sections, isIncremental: true } }
          }));
          document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: data } }));
          cartStatus.textContent = root.dataset.cartSuccess;
          const drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.showDialog === 'function') requestAnimationFrame(() => drawer.showDialog());
          emit('quiz_add_to_cart', { product_handle: button.dataset.productHandle, variant_id: button.dataset.variantId });
        } catch (error) {
          cartStatus.textContent = error.message || root.dataset.cartError;
        } finally {
          button.disabled = false;
          button.textContent = original;
        }
      });

      updateProgress();
      updateSizeCopy(answers().species || 'dog');
    };

    const initAll = (scope = document) => scope.querySelectorAll(selectors.root).forEach(init);
    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rawjoy-contact-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-zn-contact-tab]');
    if (!tab) return;
    const section = tab.closest('.zn-contact-page');
    const id = tab.dataset.znContactTab;
    section.querySelectorAll('[data-zn-contact-tab]').forEach((item) => {
      const active = item === tab;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    section.querySelectorAll('[data-zn-contact-panel]').forEach((panel) => {
      const active = panel.dataset.znContactPanel === id;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
    const panel = section.querySelector(`[data-zn-contact-panel="${CSS.escape(id)}"]`);
    panel?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  });

  } catch(e) { console.error(e); }
})();
})();
